<template>
  <div class="outer bg">
    <div class="inner behind">
      <img :src="require(`@/assets/skat/skat_swoosh.png`)" class="swoosh" />
      <img :src="require('@/assets/skat/skat_cards_behind.png')" class="cards" alt="Shiny Skat cards" />
    </div>
    <div class="shadow"></div>
    <div class="inner front">
      <img :src="require('@/assets/skat/skat_tournament_logo.png')" class="logo" alt="Skat logo" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="less" scoped>
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '../../styles/vars';
.bg {
  background: #247001 url('../../assets/skat/skat_bg_pattern.jpg');
  position: relative;
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2em;
    left: 0;
    bottom: 0;
    box-shadow: 0 -2em 0.5em -1.8em rgba(0, 0, 0, 0.35) inset;
  }
}
.swoosh {
  width: 43.0625em;
  height: 6.75em;
  margin: 0 auto;
}
.behind {
  overflow: hidden;
}
.cards {
  position: absolute;
  width: 27.125em;
  height: 7.25em;
  right: 0;
  bottom: 0;
  @media screen and (max-width: 660px) {
    right: -2em;
  }
}
.shadow {
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(237, 244, 179, 0.2) 0%, rgba(0, 0, 0, 0.1) 100%);
}
.logo {
  position: absolute;
  width: 10.75em;
  height: 6.1875em;
  left: 0;
  top: 2em;
  justify-self: center;
  @media screen and (max-width: @framemaxwidth) {
    left: 1.25em;
  }
}
</style>
